import React, { useMemo } from 'react'
import format from 'civic-champs-shared/utils/format'
import { useHasRole } from 'auth/hooks'
import { INTERNAL_ADMIN } from 'civic-champs-shared/auth/utils/permissions'
import { Group } from 'Event/components/opportunity/GroupPicker/types'
import { Row } from 'react-table'
import { ExportButton } from 'core/table/components'
import { useFeatureEnabled } from 'core/feature/hooks'

const filename = 'groups.csv'
const baseHeaders = [
  { label: 'ID', key: 'id' },
  { label: 'Group Name', key: 'name' },
  { label: 'Applicants', key: 'pendingMemberCount' },
  { label: 'Members', key: 'memberCount' },
  { label: 'Approval Type', key: 'approvalType' },
  { label: 'Automatic Check-In', key: 'automaticCheckIn' },
  { label: 'Date Created', key: 'createdAt' },
]

const formatData = (groups: Row<Group>[], includeAutomaticCheckIn: boolean) => {
  return groups.map(({ original: group }) => {
    return {
      id: group.id,
      name: group.name,
      pendingMemberCount: group.pendingMemberCount,
      memberCount: group.memberCount,
      approvalType: group.closed ? 'Limited' : 'Open',
      ...(includeAutomaticCheckIn && {
        automaticCheckIn: group.automaticHourLogging ? 'Enabled' : 'Disabled',
      }),
      createdAt: format.date(group.createdAt),
    }
  })
}
const ExportGroupsButton = ({ data, disabled }: { data: any[]; disabled?: boolean }) => {
  const isInternalAdmin = useHasRole(INTERNAL_ADMIN)
  const isAutomaticEventHourLoggingEnabled = useFeatureEnabled('AutomaticEventHourLogging')
  const headers = useMemo(
    () =>
      isAutomaticEventHourLoggingEnabled
        ? baseHeaders
        : baseHeaders.filter(header => header.key !== 'automaticCheckIn'),
    [isAutomaticEventHourLoggingEnabled],
  )
  const filteredHeaders = isInternalAdmin ? headers : headers.filter(header => header.key !== 'id')
  return (
    <ExportButton
      data={data}
      formatData={rows => formatData(rows, isAutomaticEventHourLoggingEnabled)}
      headers={filteredHeaders}
      disabled={disabled}
      filename={filename}
    />
  )
}

export default ExportGroupsButton
